import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BASE_URL from '../constent';
// Thunks for asynchronous operations

export const updateOrderDetails = createAsyncThunk(
    "shipAndShop/updateOrderDetails",
    async ({ orderId, updateData }, { rejectWithValue }) => {
      try {
        const token = localStorage.getItem("accessToken"); // Get the token from localStorage
        if (!token) throw new Error("No access token found");
  
        const response = await axios.put(
          `${BASE_URL}/shipAndShopOrders/${orderId}`, // API endpoint with order ID
          updateData, // Payload to update the order details
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add the token to the Authorization header
            },
          }
        );
  
        return response.data; // Return the updated data if the request is successful
      } catch (error) {
        return rejectWithValue(error.response?.data || "Failed to update order details");
      }
    }
  )


// Slice
const shipAndShopSlice = createSlice({
  name: 'shipAndShop',
  initialState: {
    files: [],
    orders: [],
    specificOrder: null,
    userBoxOrders: [],
    userCounts: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle errors
      .addMatcher(
        (action) => action.type.endsWith('rejected'),
        (state, action) => {
          state.error = action.payload;
          state.loading = false;
        }
      );
  },
});

export default shipAndShopSlice.reducer;
